import { render } from "./runApp.vue?vue&type=template&id=16afd33c&scoped=true"
import script from "./runApp.vue?vue&type=script&lang=js"
export * from "./runApp.vue?vue&type=script&lang=js"

import "./runApp.vue?vue&type=style&index=0&id=16afd33c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-16afd33c"

export default script